var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLixo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-lixo 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 6L14 3H10L7 6H5.5V20C5.5 21.1 6.4 22 7.5 22H16.5C17.6 22 18.5 21.1 18.5 20V6H17Z",
    fill: "#9575CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.25 19.5H11.75C11.35 19.5 11 19.15 11 18.75V9.25C11 8.85 11.35 8.5 11.75 8.5H12.25C12.65 8.5 13 8.85 13 9.25V18.75C13 19.15 12.65 19.5 12.25 19.5ZM15.75 19.5C15.35 19.5 15 19.15 15 18.75V9.25C15 8.85 15.35 8.5 15.75 8.5C16.15 8.5 16.5 8.85 16.5 9.25V18.75C16.5 19.15 16.15 19.5 15.75 19.5ZM8.25 19.5C7.85 19.5 7.5 19.15 7.5 18.75V9.25C7.5 8.85 7.85 8.5 8.25 8.5C8.65 8.5 9 8.85 9 9.25V18.75C9 19.15 8.65 19.5 8.25 19.5Z",
    fill: "#7454B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.5 4H18.5C19.05 4 19.5 4.45 19.5 5V6H4.5V5C4.5 4.45 4.95 4 5.5 4Z",
    fill: "#B39DDB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLixo);
export default __webpack_public_path__ + "static/media/iconLixo.693b6528b522c03708abbfe50060b234.svg";
export { ForwardRef as ReactComponent };